export default {
    namespaced: true,

    state: () => ({
        qtUrgent: 0,
        qtSystem: 0,
        qtAssignedToMe: 0,
        listToDoByCategory: [],
        qtdWorkOrder: 0,
        qtdWorkOrderRequest: 0,
        qtdInspection: 0,
        qtdInspectionRequest: 0,
        jobsPendingAcceptance: null
    }),

    mutations: {
        setNotifications(state, payload) {
            Object.assign(state, payload);
        }
    },

    actions: {}
};